export * from './app.service';
export * from './galeria.service';
